(() => {
  const priceSelector = [
    '.price-item',
    '.mrartz-size-price',
    '.mrartz-mobile-sticky-price',
    '.cart-item__price-wrapper',
    '.totals__total-value',
    '.product-option',
    '.unit-price'
  ].join(',');

  const decimalPattern = /([.,]\d{2})(?!\d)/g;

  function removeDecimals(root) {
    const targets = [];

    if (root?.nodeType === Node.ELEMENT_NODE && root.matches?.(priceSelector)) {
      targets.push(root);
    }

    if (root?.querySelectorAll) {
      targets.push(...root.querySelectorAll(priceSelector));
    }

    targets.forEach((target) => {
      const walker = document.createTreeWalker(target, NodeFilter.SHOW_TEXT);
      let node;

      while ((node = walker.nextNode())) {
        const formatted = node.nodeValue.replace(decimalPattern, '');
        if (formatted !== node.nodeValue) node.nodeValue = formatted;
      }
    });
  }

  removeDecimals(document);

  document.addEventListener('DOMContentLoaded', () => {
    removeDecimals(document);

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'characterData' && mutation.target.parentElement) {
          removeDecimals(mutation.target.parentElement);
        }

        mutation.addedNodes.forEach((node) => removeDecimals(node));
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
  });
})();
